module.exports = __webpack_public_path__ + "static/media/base-04.51709a02.jpg";